var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-info",class:_vm.column ? 'row-info--column' : 'row-info--row'},[_c('div',{staticClass:"key"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.$t(_vm.label)))]})],2),_c('div',{class:['value', _vm.valueClass]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }